import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { selfserviceAgreedproducts } from "../../redux/actions";
import { useSelector, useDispatch } from "react-redux";
import { addToCarts, setCart } from "../../redux/actions";
import AddingProductToCartModal from "../../components/modals/AddingProductToCartModal";
import usePrice from "../../hooks/usePrice";
import useFormat from "../../hooks/useFormat";

const AgreedProductsPage = () => {
  const [products, setproducts] = useState([]);
  const [error, setError] = useState(null);
  const user = useSelector((state) => state?.user_data);
  const currency = user?.user_data?.company?.currency?.value;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user_data = useSelector((state) => state?.user_data?.user_data) ?? {};
  const region = useSelector((state) => state.region.region);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [locationList, setLocationList] = useState([]);
  const [variation, setVariation] = useState(false);
  const [quant, setQuant] = useState([]);
  const { formatPrice } = useFormat();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const data = await selfserviceAgreedproducts();
        setproducts(data || []); // Ensure orders exist
      } catch (err) {
        setError(err.message);
      }
    };
    fetchOrders();
  }, []);

  // State for data
  const [data, setData] = useState([]);

  // State for search query
  const [searchQuery, setSearchQuery] = useState("");

  // State for sorting order
  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'

  // Effect to load dynamic data when products are available
  useEffect(() => {
    if (products?.page?.data?.products) {
      console.log(products?.page?.data?.products);
      const formattedData = products.page.data.products.map(
        (product, index) => ({
          id: index + 1, // Ensure unique ID
          image:
            product?.brand[0]?.logo[0]?.files?.medium?.url ||
            "/public/assets/images/logo/Image-coming-soon.png",
          name: product?.name || "Unnamed Product",
          quantity: 1, // Default quantity
          price: parseFloat(product?.company_special_price) || 0,
          url: product?.url?.en
            ? product.url.en.startsWith("/")
              ? product.url.en.slice(1)
              : product.url.en
            : "", // Ensure valid URL
          product_variations: product?.product_variations,
          original_price: product?.min_base_gross_price,
        })
      );
      setData(formattedData);
    }
  }, [products]); // Run when `products` updates

  // Function to handle quantity increment
  const handleIncrement = (id) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  // Function to handle quantity decrement
  const handleDecrement = (id) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id && item.quantity > 1
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  };

  // Filter and sort data based on search query and sorting order
  const filteredData = data
    .filter((item) =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .sort((a, b) => {
      // Ensure prices are parsed correctly, handling undefined/null values
      const priceA = parseFloat(a.price) || 0;
      const priceB = parseFloat(b.price) || 0;

      return sortOrder === "asc" ? priceA - priceB : priceB - priceA;
    });

  // Total count of filtered items
  //const totalCount = filteredData.length;

  const addToCart = async (selectedVariation, quantity) => {
    setVariation(selectedVariation);
    setQuant(quantity);

    const toastId = "addToCartError";
    const successToastId = "addToCartSuccess";

    //single location
    if (user_data?.locations?.length === 1) {
      const locationId = user_data?.locations[0]?.id || undefined;
      try {
        const createCart = await addToCarts(
          selectedVariation,
          quantity,
          locationId,
          region,
          dispatch
        );
        dispatch(setCart(createCart));

        //navigate("/cart/one-time");
        setTimeout(() => {
          if (!toast.isActive(successToastId)) {
            toast.success(
              <div
                style={{
                  width: "380px",
                  height: "120px",
                }}
              >
                <p className="mt-10 mb-20">Product added to cart</p>
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <button
                    className="btn btn-sm p-10 bg-main-product-50 hover-bg-main-product-50 flex-fill text-center me-2"
                    onClick={() => toast.dismiss(successToastId)}
                  >
                    Shop More
                  </button>

                  <button
                    className="btn btn-sm p-10 bg-main-product-50 hover-bg-main-product-50 flex-fill text-center ms-2"
                    onClick={() => (window.location.href = "/cart/one-time")}
                  >
                    View Cart
                  </button>
                </div>
              </div>,
              { toastId: successToastId }
            );
          }
        }, 500);

        return;
      } catch (error) {
        console.log(error);
      }
      return;
    } else if (user_data?.locations?.length === 0) {
      navigate("/self-service/mycompany/actions");
      if (!toast.isActive(toastId)) {
        toast.error(
          "Please add delivery location to add the product in carts.",
          { toastId }
        );
      }
      return;
    } else if (user_data?.locations?.length > 1) {
      setLocationList(user_data?.locations);
      setIsModalOpen(true);
    } else {
      console.warn("noo actions ");
    }
  };

  return (
    <>
      {isModalOpen && (
        <AddingProductToCartModal
          onClose={() => setIsModalOpen(false)}
          locationList={locationList}
          productVariation={variation}
          quantity={quant}
          region={region}
        />
      )}

      <section className="hot-deals pt-20">
        {/* component 1 about us*/}
        <div className="container container-lg">
          <div className="section-heading">
            <div className="flex-between flex-wrap gap-8">
              <h2 className="mb-0 text-blue">MY AGREED PRODUCTS</h2>
            </div>
          </div>
        </div>
        <div className="container container-lg">
          <div className="row gy-4">
            <div className="col-lg-12">
              <div className="flex-between flex-wrap gap-8 mb-40">
                {/* Search Input */}
                <input
                  type="text"
                  placeholder="Search by product name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44"
                />
                <div className="flex-align gap-16">
                  <div className="flex-align gap-8">
                    <select
                      className="common-input form-select rounded-pill border border-gray-100 d-inline-block ps-20 pe-36 h-48 py-0 fw-medium"
                      value={sortOrder}
                      onChange={(e) => setSortOrder(e.target.value)}
                    >
                      <option value="asc">Price asc</option>
                      <option value="desc">Price dsc</option>
                    </select>
                    <span className="text-gray-900 flex-shrink-0">
                      {data?.length} Items
                    </span>
                  </div>
                </div>
              </div>

              <div className="cart-table border border-gray-100 rounded-8">
                <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                  {/* Table */}
                  <div>
                    {/* Table */}
                    <table className="table rounded-8 overflow-hidden">
                      <thead>
                        <tr className="border-bottom border-neutral-100">
                          <th className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100">
                            S.No
                          </th>
                          <th className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100">
                            Image
                          </th>
                          <th className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100">
                            Product Name
                          </th>
                          <th className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100">
                            Quantity
                          </th>
                          <th className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100">
                            Price
                          </th>
                          <th className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData && filteredData.length > 0 ? (
                          filteredData.map((item, index) => (
                            <tr key={item.id}>
                              <td className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100">
                                {index + 1}
                              </td>
                              <td className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100">
                                <div className="table-product d-flex align-items-center gap-24">
                                  <Link
                                    to="/product-details-two"
                                    className="table-product__thumb border border-gray-100 rounded-8 flex-center"
                                  >
                                    <img src={item?.image} alt="" />
                                  </Link>
                                </div>
                              </td>
                              <td
                                className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100"
                                style={{
                                  maxWidth: "350px",
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                  overflow: "visible",
                                  textOverflow: "unset",
                                }}
                              >
                                <div className="table-product__content text-start">
                                  <h6 className="title text-lg fw-semibold mb-8">
                                    <Link
                                      to={`/product-details/${encodeURIComponent(
                                        item.url
                                      )}`}
                                      className="break-words whitespace-normal"
                                      tabIndex={0}
                                    >
                                      {item.name}
                                    </Link>
                                  </h6>
                                </div>
                              </td>
                              <td className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100">
                                <div className="d-flex align-items-center gap-16">
                                  <button
                                    className='class="ph ph-minus " w-52 h-52 bg-main-600 text-white text-xl hover-bg-main-600 hover-text-white flex-center rounded-circle'
                                    onClick={() => handleDecrement(item.id)}
                                  >
                                    -
                                  </button>
                                  <span className="text-lg h6 mb-0 fw-semibold">
                                    {item.quantity}
                                  </span>
                                  <button
                                    className='class="ph ph-minus " w-52 h-52 bg-main-600 text-white text-xl hover-bg-main-600 hover-text-white flex-center rounded-circle'
                                    onClick={() => handleIncrement(item.id)}
                                  >
                                    +
                                  </button>
                                </div>
                              </td>
                              <td className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100">
                                <span
                                  className="text-lg h6 mb-0 fw-semibold"
                                  style={{ color: "#4887c7" }}
                                >
                                  {/* {currency}{" "} */}
                                  {/* {item?.price?.toFixed(
                                    currency === "OMR" ? 3 : 2
                                  )} */}
                                  {formatPrice(item?.price)}
                                </span>
                                <br />
                                <span className="text-lg h6 mb-0 fw-semibold">
                                  <del>
                                    {/* {currency}{" "} */}
                                    {/* {item?.originalPrice?.toFixed(
                                      currency === "OMR" ? 3 : 2
                                    )} */}
                                    {formatPrice(item?.original_price)}
                                  </del>
                                </span>
                              </td>
                              <td className="text-start h6 text-lg fw-bold px-30 py-16 border-end border-neutral-100">
                                <span className="center text-lg h6 mb-0 fw-semibold">
                                  <a
                                    className="w-52 h-52 bg-main-600 text-white text-xl hover-bg-main-600 hover-text-white flex-center rounded-circle"
                                    href="/product-details"
                                    onClick={(e) => {
                                      e.preventDefault(); // Prevent navigation
                                      addToCart(
                                        item.product_variations,
                                        item.quantity
                                      ); // Send selected variation & quantity
                                    }}
                                  >
                                    <i className="ph ph-shopping-cart "></i>
                                  </a>
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={6} style={{ textAlign: "center" }}>
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AgreedProductsPage;
